module.exports = __webpack_public_path__ + "img/3.a349a45b.png";